var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('line',{attrs:{"x1":"35","y1":"0","x2":"35","y2":"70","stroke-linecap":"round","stroke-width":"4"}}),_c('line',{attrs:{"x1":"0","y1":"35","x2":"70","y2":"35","stroke-linecap":"round","stroke-width":"4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }